<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Project Salary Package 
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm">Delete</b-button>
          <b-button variant="primary mr-1" @click="showFilter=!showFilter"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter" class="ml-2 mr-2">
          <b-col lg="5">
                <b-input-group >
                    <b-input-group-prepend><label>Project</label></b-input-group-prepend>
                    <b-form-input readonly v-model="tblData.projectname" ></b-form-input>
                    <b-input-group-append>
                        <b-btn text="Button" @click="lkuCustomerShow=true" ><i class="fa fa-search"></i></b-btn>
                    </b-input-group-append>
                </b-input-group>
          </b-col>
          <b-col lg="5">
              <b-input-group >
                <b-input-group-prepend><label>Job Position</label></b-input-group-prepend>
                <b-form-input v-model="tblData.pangkat" placeholder="Position Name"></b-form-input>
              </b-input-group>
        </b-col>
        <b-col lg="2">
          <b-row>
            <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
            <b-button class="btn btn-secondary" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
          </b-row>
        </b-col>
      </b-row>                      
          <b-table
            class="mb-0 text-nowrap"
            ref="tblEmployee"
            responsive
            striped hover 
            style="font-size:smaller;" 
            :items="data"
            :fields="fields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            :key="tblData.limit" 
            @row-clicked="selectEmployee"
            show-empty
          >
          <template v-slot:cell(gapok)="data">
           {{data.item.gapok|numFormat}}
          </template>
          <template v-slot:cell(rekapfix)="data">
           {{data.item.rekapfix|numFormat}}
          </template>
          <template #empty="scope">
            <h6 class="text-center">{{ scope.emptyText }}</h6>
          </template>
          <template #emptyfiltered="scope">
            <h6 class="text-center">{{ scope.emptyFilteredText }}</h6>
          </template>
        </b-table>

        <b-row class="mt-1">
          <b-col cols="4">
            <div>
              Showing {{(tblData.page - 1) * tblData.limit + 1}}
              to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
              of {{tblData.total}} entries
            </div>
          </b-col>
          <b-col cols="4" >
              <b-form-group label-cols=3 label="Limit per page"  style="margin-top:0 !important;">
              <b-form-select :options="[10, 15, 20, 25]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
              </b-form-group>
          </b-col>        
          <b-col cols="4">            
            <b-pagination
              align="right"
              :total-rows="tblData.total"
              :per-page="tblData.limit"
              v-model="tblData.page"
            ></b-pagination>
          </b-col>
        </b-row>
    </b-card>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
          <p class="mb-1">1 record is about to be permanently deleted</p>
          <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
        </b-modal>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Client/Project" :centered="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>        
  </div>
</template>
<style lang="scss">
    .input-group {
        .input-group-prepend {
          padding-bottom:2px;
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 100px;
            }
        }
    }
</style>
<script>
import lkuCustomer from "../lookup/lkuCustomers";
import projectpaket from "../../apis/projectpaket";
import Loading from 'vue-loading-overlay';
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      fields: [
          {
            key: "CustName",
            label: "Client/Project",
            sortable: true
          },
          {
            key: "pangkat",
            label: "Position",
            sortable: true
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "gapok",
            thStyle: "width:100px",
            label: "Basic Salary",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "rekapfix",
            thStyle: "width:100px",
            label: "Estimasi THP",
            tdClass: "text-right",
            sortable: true
          },
      ],
      tblData: {
        page: 1,
        limit: 10,
        total: 0,
        sortBy: null,
        sortDesc: false, terminate:'0'
      },
      model:{},
      isLoading:false,
      showDelConfirm: false,
      showFilter:false,
      lkuCustomerShow:false,
      showImgTool:false,
      showList:true,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
    };
  },
  components :{Loading, lkuCustomer},
  methods: {
    onSelectLkuCustomer: async function (_selected) {
        this.tblData.projectname = _selected.CustName.trim() + ' | ' + _selected.CustCode.trim();
        this.tblData.projectid = _selected.customer_id;
        this.lkuCustomerShow=false;
    },
    data: async function(ctx) {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.dealpjxlist) {
            this.tblData[key] = filter.dealpjxlist[key];
            filtered=true;
        }
        if (filtered === true) {
          this.showFilter=filtered;
          delete filter.dealpjxlist;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading = true;
      let list = await projectpaket.list(this.tblData);
      this.lkuLoading = false;
      return list;  
    },
    selectEmployee(record,index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    refresh() {
      this.$refs.tblEmployee.refresh();
    },
    clearFilter(ctx) {
        this.tblData.pangkat = '';
        this.tblData.projectid = '';
        this.tblData.projectname = '';
        // this.refresh();
    },    
    add: function(data) {
          const filter = this.$store.state.filter;
          filter.dealpjxlist=this.tblData;
          this.$store.commit("filter", filter);
          router.push({name: 'hrm.salarydealpjxfrm'});
    },
    edit: function() {
        if (this.model) {
          const filter = this.$store.state.filter;
          filter.dealpjxlist=this.tblData;
          this.$store.commit("filter", filter);
          router.push({name: 'hrm.salarydealpjxfrm', params: { paketid: this.model.paketid}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      await projectpaket.remove(this.model);
      this.refresh();
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await projectpaket.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message, 'Error Info',10000);
            } else {
                toastr.error(JSON.stringify(error), 'Error Info',10000);
            }
        }
    },
    closeFrm(){
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
